import React, { useState } from "react";
// import React from "react";
const QuestionBox = ({ question, answers, selected }) => {
  const [answer, setAnswer] = useState(answers);
  return (
    <div className="questionBox">
      <div className="question">{question}</div>

      {answer.map((text, index) => (
        <button
          key={index}
          className="answerBtn"
          onClick={() => {
            setAnswer([text]);
            selected({ text });
          }}
        >
          {text}
        </button>
      ))}
    </div>
  );
};

export default QuestionBox;
